import ProductService from 'services/product.service';
import UserService from 'services/user.service';

import LoginCheckoutService from './login-checkout.service';

const loginCheckoutService = new LoginCheckoutService();

export default class LikeService {
  public static readonly USER_TYPE = 'userService';
  public static readonly PRODUCT_TYPE = 'productService';

  productService = null;
  userService = null;

  constructor() {
    this.productService = new ProductService();
    this.userService = new UserService();
  }

  async getLocalStorageLike() {
    const likedData = loginCheckoutService.getCheckoutData();

    if (!likedData) {
      return;
    }

    const parsedLikedData = JSON.parse(likedData);

    if (!('liked' in parsedLikedData)) {
      return;
    }

    if ('liked' in parsedLikedData) {
      loginCheckoutService.clearCheckoutData();
    }

    return parsedLikedData;
  }

  async changeLikeStatus(likedData, typeOfService) {
    if (!likedData) {
      return;
    }

    const { liked, id, searchGuid, recommendationId, recommendationEngine } = likedData;
    const likeActionsMap = {
      [LikeService.USER_TYPE]: {
        like: () => this.userService.likeUser(id),
        unlike: () => this.userService.unlikeUser(id),
      },
      [LikeService.PRODUCT_TYPE]: {
        like: () => this.productService.likeProduct(id, { searchGuid, recommendationId, recommendationEngine }),
        unlike: () => this.productService.unlikeProduct(id, { searchGuid, recommendationId, recommendationEngine }),
      },
    };

    try {
      if (id) {
        const action = !liked ? likeActionsMap[typeOfService].unlike : likeActionsMap[typeOfService].like;

        try {
          return await action();
        } catch (err) {
          console.error(err);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
}
